import { Action, Dispatch } from "redux";
import axios from "../../axios/axios";
import { Auth } from "../../ts/Auth";
import { Skupina } from "../../ts/CSSkupiny";
import { csSkupinyModel } from "../../api/models/csSkupinyModel";

export const ADD_SKUPINA =
  (skupina: Skupina, auth: Auth) =>
  async (dispatch: Dispatch<Action<"ADD_SKUPINA">>) => {
    const req = await axios.post("/cs-skupiny/add", {
      skupina,
      id: auth.user._id,
    });

    skupina._id = req.data._id;

    dispatch({
      type: "ADD_SKUPINA",
      payload: skupina,
    });
  };

export const EDIT_SKUPINA =
  (skupina: Skupina) => async (dispatch: Dispatch<Action<"EDIT_SKUPINA">>) => {
    await axios.post("/cs-skupiny/edit", {
      skupina,
    });

    dispatch({
      type: "EDIT_SKUPINA",
      payload: skupina,
    });
  };

export const DELETE_SKUPINA =
  (skupina: Skupina, auth: Auth) =>
  async (dispatch: Dispatch<Action<"DELETE_SKUPINA">>) => {
    await axios.post("/cs-skupiny/delete", {
      skupina,
      id: auth.user._id,
    });
    dispatch({
      type: "DELETE_SKUPINA",
      payload: skupina,
    });
  };

export const GET_SKUPINY = async () => {
  const skupiny = await csSkupinyModel.getAllCSSkupiny();

  return {
    type: "SET_SKUPINY",
    payload: skupiny,
  };
};
